import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Components
import Notifications from './Notifications';

// Selectors
import {
  getContactInfoProperty,
  getPersonInfo
} from 'store/reducers/user/personInfo/selectors';

// Actions
import { updateProfile } from 'store/reducers/user/personInfo/actions';

const mapStateToProps = state => {
  const emailAddress = getContactInfoProperty(state, 'emailAddress');
  const phonePrivacyPreference = getContactInfoProperty(
    state,
    'phonePrivacyPreference'
  ).split(',');
  const emailPrivacyPreference = getContactInfoProperty(
    state,
    'emailPrivacyPreference'
  ).split(',');
  const textPrivacyPreference = getContactInfoProperty(
    state,
    'textPrivacyPreference'
  ).split(',');
  return {
    personInfo: getPersonInfo(state),
    email: emailAddress ? emailAddress.email : '',
    emailPrivacyPreference,
    phonePrivacyPreference,
    textPrivacyPreference,
    privacySettings: {
      emailSpecialOffers: Boolean(+emailPrivacyPreference[3]),
      emailRemindUpcoming: Boolean(+emailPrivacyPreference[0]),
      emailRemindReschedule: Boolean(+emailPrivacyPreference[1]),
      emailRemindOverdue: Boolean(+emailPrivacyPreference[2]),
      phoneRemindUpcoming: Boolean(+phonePrivacyPreference[0]),
      phoneRemindReschedule: Boolean(+phonePrivacyPreference[1]),
      phoneRemindOverdue: Boolean(+phonePrivacyPreference[2]),
      textRemindUpcoming: Boolean(+textPrivacyPreference[0]),
      textNotifyStatus: Boolean(+textPrivacyPreference[6])
    }
  };
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    { updateProfile }
  )
)(Notifications);



// WEBPACK FOOTER //
// ./src/components/pages/User/Notifications/NotificationsContainer.js